const pluralize = (count, singular, plural) =>
  `${count} ${count === 1 ? singular : plural}`;

export function buildUnassignedMailPills(mail) {
  const pills = [];

  if (mail.status === "assigned" && mail.lead) {
    pills.push({ tone: "ok", label: `Vinculado: ${mail.lead.name}` });
  }

  if (mail.is_automated) {
    pills.push({ tone: "muted", label: "Parece automático" });
  } else {
    if (mail.status === "pending") {
      if (mail.suggested_lead) {
        pills.push({
          tone: "suggested",
          label: `Sugerido: ${mail.suggested_lead.lead_name}`,
        });
      } else {
        pills.push({ tone: "muted", label: "Sin lead sugerido" });
      }
    }

    if (mail.new_contacts > 0) {
      pills.push({
        tone: "warn",
        label: pluralize(mail.new_contacts, "contacto nuevo", "contactos nuevos"),
      });
    }

    if (mail.known_contacts > 0) {
      pills.push({ tone: "ok", label: `${mail.known_contacts} en base` });
    }
  }

  if (mail.status === "spam") {
    pills.push({ tone: "muted", label: "Spam" });
  }

  return pills;
}

export const getSenderDisplayName = (mail) =>
  mail?.from_name?.trim() || mail?.from_email || "";
